import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IDailyReceipt, IDailyReceiptsQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IDailyReceipt>, IDailyReceiptsQueryParams>>(undefined as any);
